// Recovered compiled webpack factory 53663. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "appBootstrap", {
      enumerable: !0,
      get: function () {
        return a;
      },
    }));
  let n = r(94681);
  function a(e) {
    var t, r;
    ((t = self.__next_s),
      (r = () => {
        e();
      }),
      t && t.length
        ? t
            .reduce((e, t) => {
              let [r, a] = t;
              return e.then(
                () =>
                  new Promise((e, t) => {
                    let o = document.createElement("script");
                    (a && (0, n.setAttributesFromProps)(o, a),
                      r
                        ? ((o.src = r), (o.onload = () => e()), (o.onerror = t))
                        : a && ((o.innerHTML = a.children), setTimeout(e)),
                      document.head.appendChild(o));
                  }),
              );
            }, Promise.resolve())
            .catch((e) => {
              console.error(e);
            })
            .then(() => {
              r();
            })
        : r());
  }
  ((window.next = { version: "15.5.18", appDir: !0 }),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
